export default __webpack_public_path__ + "static/media/HR.04fcce54.svg";